/* Cannot use common file power-review-override.js for both plp and pdp
 * Overriding with with parent clasName in pdp is not applying pdp specific change
 * Example: Ratings, 1 star to appear on PLP. But in PDP all the stars
 */

export default {
    baseStyle: () => ({
        '.p-w-r .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
            width: '20px',
            height: '20px',
            marginRight: '0',
            padding: '0'
        },
        '.p-w-r .pr-snippet div': {
            lineHeight: '16.8px',
            fontWeight: 'medium'
        },
        '.p-w-r .pr-snippet .pr-snippet-stars-png .pr-snippet-rating-decimal': {
            border: 0,
            fontSize: '14px',
            fontFamily: 'lato',
            fontWeight: 'bold',
            color: 'textColor'
        },
        '.pr-no-reviews, .pr-category-snippet__total, .pr-snippet-rating-decimal': {
            display: 'none'
        },
        '.p-w-r .pr-snippet-stars, .p-w-r .pr-review-snapshot, .p-w-r .pr-read-review, .p-w-r .pr-review-display, .p-w-r pr-rd-no-reviews':
            {
                background: 'transparent'
            },
        '.p-w-r .pr-review-display': {background: 'transparent'},
        '.p-w-r a, .p-w-r .pr-read-review a, .p-w-r .pr-review-display a': {color: 'primaryColor'},
        '.p-w-r .pr-category-snippet': {display: 'block', marginLeft: '8px', marginTop: '5px'},
        '.p-w-r .pr-snippet .pr-category-snippet__total': {
            display: 'none'
        },
        '.p-w-r .pr-snippet-stars-reco-inline .pr-snippet-read-and-write a': {
            fontSize: '14px !important',
            fontFamily: 'lato !important',
            color: 'textColor',
            paddingLeft: '0',
            lineHeight: '16.8px',
            fontWeight: 'medium'
        },
        '.p-w-r .pr-snippet-stars-reco-inline.pr-snippet-compact .pr-snippet-read-and-write': {
            marginTop: '0',
            marginLeft: '4px'
        },
        '.p-w-r .pr-snippet-stars-reco-inline .pr-snippet-stars-reco-reco': {
            display: 'none'
        }
    }),
    sizes: {
        md: {
            '.p-w-r .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
                width: '12px',
                height: '12px'
            },
            '.p-w-r .pr-snippet div': {
                fontSize: '12px',
                lineHeight: '12px',
                fontFamily: `'Source Sans Pro', sans-serif`
            }
        }
    }
}
